import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=3f3f3bae&scoped=true"
import script from "./sample.vue?vue&type=script&lang=js"
export * from "./sample.vue?vue&type=script&lang=js"
import style0 from "./sample.vue?vue&type=style&index=0&id=3f3f3bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3f3bae",
  null
  
)

export default component.exports